module.exports = __webpack_public_path__ + "static/media/dec-snapshot-process.d17edf29.jpg";